import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export const WhyItDidntWork = () => {
  const reasons = ['La meditación secular ofrece calma momentánea, pero no llena el vacío profundo del alma.', 'Los libros de teología complejos son imposibles de concentrar cuando estás en medio de una crisis.', 'Los consejos de "solo ten más fe" ignoran que tu cuerpo está sufriendo una respuesta química real.', 'El scroll infinito en redes sociales solo sobreestimula tu cerebro y empeora el pánico.'];
  return <Section variant="navy-light" data-id="element-182">
      <FadeIn data-id="element-183">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-184">
          Por qué lo que has intentado{' '}
          <span className="text-red-400/90" data-id="element-185">no ha funcionado</span>
        </h2>
      </FadeIn>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-186">
        {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-187">
            <div className="flex items-start gap-4 p-6 bg-navy rounded-xl border border-white/5" data-id="element-188">
              <XCircle className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-1" data-id="element-189" />
              <p className="text-lg text-cream-muted leading-relaxed" data-id="element-190">
                {reason}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};